module.exports = __webpack_public_path__ + "static/media/voxelcars.b2859cdb.png";